<template>
  <div style="height:100%;color:#777777;display:flex;flex-direction: column">
    <hi-row
      separator
      class="sec-title pa-3 px-10"
      style="height:100px;width:100%;"
    >
      <div class="flex-row-base">
        <span class="ui-text d-inline-block text-right mr-2" style="width:50px;"
          >Subject: </span
        ><span class="ellipsis">{{ email.subject }}</span>
      </div>
      <div>
        <span class="ui-text d-inline-block text-right mr-2" style="width:50px"
          >From:</span
        ><span style="font-size:.8em">{{ email.from }}</span>
      </div>
      <div>
        <span class="ui-text d-inline-block text-right mr-2" style="width:50px"
          >To:</span
        ><span style="font-size:.8em">{{ email.to }}</span>
      </div>
    </hi-row>
    <!--    Toolbar to toggle display status. Not developed due to rare usage-->
    <!--    <hi-row separator gutter py-sm text-center>-->
    <!--      <span>TrueView</span> HTML Text</hi-row-->
    <!--    >-->

    <div style="flex-grow:1;overflow: auto" v-if="stat === 'true'">
      <div
        class="pa-10"
        v-html="html"
        style="overflow: auto;width:100%;height:100%;background-color: white;"
      ></div>
    </div>
    <textarea
      v-if="stat === 'text'"
      style="flex-grow:1;padding:30px"
      contenteditable="false"
      v-model="email.text"
    ></textarea>
    <textarea
      v-if="stat === 'html'"
      style="flex-grow:1;padding:30px"
      contenteditable="false"
      v-model="email.html"
    ></textarea>
    <div
      style="height:59px;width:100%;flex-shrink: 0;border-top:1px solid #cccccc"
      class="sec-tools flex-block-center"
    >
      <div>
        <span class="ui-text-clickable ma-5" @click="parse(false)">{{
          email.parsed ? "Re-Parse" : "Parse"
        }}</span>
        <span class="ui-text-clickable ma-5">Delete</span>
      </div>
    </div>
  </div>
</template>

<script>
import HiRow from "@/components/scaffold/HiRow";
import { api } from "@/api";
import hive from "@/hive";
import Formatter from "@/hive/Formatter";
// import { collections } from "@/db";
// const styleRegex = /<style(.|\n)*<\/style>/gim;
export default {
  name: "EmailViewer",
  components: { HiRow },
  props: {
    email: {
      type: Object
    }
  },
  data() {
    return {
      stat: "true"
    };
  },
  methods: {
    async parse(save) {
      try {
        const result = await api.leads.parseInboundEmail(this.email.id, save);
        console.log(result);
        if (save) {
          hive.toastSuccess("Parse email saved!");
        } else {
          let html = "Parse email successfully with result: <br/><br/>";
          for (let key in result) {
            let val = result[key];
            if (key === "dateCreated") {
              val = Formatter.timestamp(val, true);
              val += "\n" + JSON.stringify(result[key]);
            }
            html += key + " : " + val + "<br/>";
          }
          html += "<br/> Do you want to save the result?";
          const yes = await hive.confirm(html);
          if (yes) await this.parse(true);
        }
      } catch (e) {
        console.log(e.message);
        if (!save) {
          await hive.alert(`Parse email error:<br/><br/>${e.message}`);
        } else {
          hive.toastError("Parse email save error: " + e.message);
        }
      }
    }
    // loadEmail() {
    //   this.$refs.viewer.contentWindow.document.body.innerHTML =
    //     "<style>body:{padding:50px}</style>" + this.email.html;
    // }
  },
  computed: {
    html() {
      console.log(this.email);
      // console.log(
      //   this.email.html.replaceAll(/<head(.|\n|\r)*<\/head>/gim, "xxxxxxxx")
      // );
      window.emailHtml = this.email.html;
      return this.email.html.replaceAll(/<head(.|\n|\r)*<\/head>/gim, "");
    }
  }
};
</script>

<style scoped>
.parse {
  margin: auto;
  background-color: #3d3c3a;
  color: white;
  width: 100px;
  text-align: center;
  border-radius: 0 0 10px 10px;
  opacity: 0.5;
  transition: opacity 0.5s;
  cursor: pointer;
}
.parse:hover {
  opacity: 0.7;
}
</style>
